import { render, staticRenderFns } from "./CodShipbackReqPop.vue?vue&type=template&id=183bf870&scoped=true"
import script from "./CodShipbackReqPop.vue?vue&type=script&lang=js"
export * from "./CodShipbackReqPop.vue?vue&type=script&lang=js"
import style0 from "./CodShipbackReqPop.vue?vue&type=style&index=0&id=183bf870&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183bf870",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183bf870')) {
      api.createRecord('183bf870', component.options)
    } else {
      api.reload('183bf870', component.options)
    }
    module.hot.accept("./CodShipbackReqPop.vue?vue&type=template&id=183bf870&scoped=true", function () {
      api.rerender('183bf870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/CodShipbackReqPop.vue"
export default component.exports